import React from 'react';
import { Container, Box } from '@chakra-ui/react';
import ForgotPasswordForm from '../components/auth/ForgotPasswordForm';

const ForgotPasswordPage: React.FC = () => {
  return (
    <Container maxW="container.sm" py={{ base: 6, md: 10 }} px={{ base: 4, md: 6 }}>
      <Box>
        <ForgotPasswordForm />
      </Box>
    </Container>
  );
};

export default ForgotPasswordPage;
